import React from 'react';
import {NavLink} from 'react-router-dom';
import 'jquery-slimscroll/jquery.slimscroll.min';
import PropTypes from "prop-types";
import FFLBossLogo from '../../assets/images/FFL-logo-box.png';
import {Badge} from 'reactstrap';
import UserRoles from 'constants/UserRoles';
import Framework from "@beardeddevops/react.framework"

// Each entry defines a rail item and the children passed to NavGroup.
// Children are functions so they receive fresh history/path at render time.
const NAV_ITEMS = [
	{
		key: "dashboard",
		label: "Dashboard",
		icon: "home",
		color: "#7F77DD",
		path: "/dashboard",
	},
	{
		key: "products",
		label: "Products",
		icon: "tag",
		color: "#1D9E75",
		children: (props) => (
			<>
				<li><NavLink exact to="/products"><span className="nav-text">Firearms</span></NavLink></li>
				<li><NavLink exact to="/inventory"><span className="nav-text">Inventory</span></NavLink></li>
				{props.show_consignments
					? <li><NavLink exact to="/consignments"><span className="nav-text">Consignments</span></NavLink></li>
					: null}
				<li><NavLink exact to="/services"><span className="nav-text">Services</span></NavLink></li>
				{props.show_trade_ins
					? <li><NavLink exact to="/trade-ins"><span className="nav-text">Trade-Ins</span></NavLink></li>
					: null}
			</>
		),
	},
	{
		key: "sales",
		label: "Sales",
		icon: "shopping-cart",
		color: "#378ADD",
		children: (props) => (
			<>
				<li>
					<NavLink exact to="/checkout">
						<span className="nav-text">Checkout</span>
						{props.items > 0 &&
							<Badge pill style={{ marginLeft: "8px", backgroundColor: "red" }}>
								{props.items}
							</Badge>
						}
					</NavLink>
				</li>
				<li>
					<NavLink exact to="/sessions">
						<span className="nav-text">Paused Sales</span>
						{props.sessions > 0 &&
							<Badge pill style={{ marginLeft: "4px", backgroundColor: "red", paddingTop: "4px" }}>
								{props.sessions}
							</Badge>
						}
					</NavLink>
				</li>
				<li><NavLink exact to="/transactions"><span className="nav-text">Transactions</span></NavLink></li>
				<li><NavLink exact to="/certificates"><span className="nav-text">Gift Certificates</span></NavLink></li>
				{props.show_layaways
					? <li><NavLink exact to="/layaways"><span className="nav-text">Layaways</span></NavLink></li>
					: null}
				<li><NavLink exact to="/work-orders"><span className="nav-text">Work Orders</span></NavLink></li>
				{props.invoicing_enabled
					? <li><NavLink exact to="/invoices"><span className="nav-text">Invoices</span></NavLink></li>
					: null}
			</>
		),
	},
	{
		key: "inventory",
		label: "Manage Inventory",
		icon: "cubes",
		color: "#BA7517",
		children: () => (
			<>
				<li><NavLink exact to="/skus"><span className="nav-text">Inventory</span></NavLink></li>
				<li><NavLink exact to="/skus/classes"><span className="nav-text">Inventory Groups</span></NavLink></li>
				<li><NavLink exact to="/skus/ammoready"><span className="nav-text">AmmoReady Inventory</span></NavLink></li>
			</>
		),
	},
	{
		key: "reports",
		label: "Reports",
		icon: "bar-chart",
		color: "#D4537E",
		children: () => (
			<>
				<li><NavLink exact to="/reports/inventory_report"><span className="nav-text">Inventory Report</span></NavLink></li>
				<li><NavLink exact to="/reports/sales_tax"><span className="nav-text">Sales Tax Report</span></NavLink></li>
				<li><NavLink exact to="/reports/taxable_breakdown"><span className="nav-text">Taxable Breakdown</span></NavLink></li>
				<li><NavLink exact to="/reports/sales_report"><span className="nav-text">Sales Report</span></NavLink></li>
				<li><NavLink exact to="/reports/sales_by_category"><span className="nav-text">Sales by Category</span></NavLink></li>
				<li><NavLink exact to="/reports/employee_sales"><span className="nav-text">Employee Sales</span></NavLink></li>
				<li><NavLink exact to="/reports/layaway_report"><span className="nav-text">Layaway Report</span></NavLink></li>
				<li><NavLink exact to="/reports/work_order_report"><span className="nav-text">Work Order Report</span></NavLink></li>
				<li><NavLink exact to="/reports/invoice_report"><span className="nav-text">Invoice Report</span></NavLink></li>
				<li><NavLink exact to="/reports/year_end_report"><span className="nav-text">Year End Report</span></NavLink></li>
			</>
		),
	},
	{
		key: "customers",
		label: "Customers",
		icon: "users",
		color: "#D85A30",
		children: () => (
			<>
				<li><NavLink exact to="/customers"><span className="nav-text">All Customers</span></NavLink></li>
			</>
		),
	},
	{
		key: "memberships",
		label: "Memberships",
		icon: "id-card-o",
		color: "#25A5B1",
		children: (props) => (
			<>
				<li><NavLink exact to="/memberships"><span className="nav-text">Members</span></NavLink></li>
				{!props.isEmployee
					? <li><NavLink exact to="/memberships/history"><span className="nav-text">History</span></NavLink></li>
					: null}
			</>
		),
	},
	{
		key: "range-manager",
		label: "Range Manager",
		icon: "crosshairs",
		color: "#C39B22",
		children: () => (
			<>
				<li><NavLink exact to="/range-manager"><span className="nav-text">Dashboard</span></NavLink></li>
			</>
		),
	},
	{
		key: "account",
		label: "Account",
		icon: "user-circle",
		color: "#639922",
		children: (props) => (
			<>
				<li><NavLink exact to="/users"><span className="nav-text">Users</span></NavLink></li>
				<li><NavLink exact to="/registers"><span className="nav-text">Registers</span></NavLink></li>
				<li><NavLink exact to="/kiosks"><span className="nav-text">Kiosks</span></NavLink></li>
				<li><NavLink exact to={"/locations/" + props.rootState?.location?.Pkey ?? ""}><span className="nav-text">Locations</span></NavLink></li>
				<li><NavLink exact to="/settings"><span className="nav-text">Settings</span></NavLink></li>
			</>
		),
	},
	{
		key: "help",
		label: "Help & Support",
		icon: "question-circle",
		color: "#48494b",
		externalUrl: "https://fflsoftwarepro.freshdesk.com/support/tickets/new",
	}
];

class SidebarContent extends React.Component {
	constructor(props) {
		super(props);

		// Derive initial active section from current route
		const current = props.history.location?.pathname ?? '';
		const activeItem =
			NAV_ITEMS.find((item) => current.startsWith(item.targetPath)) ??
			NAV_ITEMS[0];

		this.state = {
			activeKey: activeItem.key,
		};

		this.handleRailClick = this.handleRailClick.bind(this);
	}

	componentDidMount() {
		const isCollapsed = this.state.activeKey === null || this.state.activeKey === 'dashboard';
		this.props.onCollapse(isCollapsed);
	}

	handleRailClick = (key) => {
		const item = NAV_ITEMS.find((i) => i.key === key);

		if (item?.externalUrl) {
			window.open(item.externalUrl, "_blank");
			return;
		}

		if (item?.path) {
			this.props.history.push(item.path);
			this.setState({ activeKey: 'dashboard' });
			this.props.onCollapse(item.key === 'dashboard');
			return;
		}

		this.setState((prev) => {
			const newKey = prev.activeKey === key ? null : key;
			this.props.onCollapse(newKey === null);
			return { activeKey: newKey };
		});
	}

	render() {
		const {  history } = this.props;
		const { activeKey } = this.state;
		const path = history.location?.pathname;
		const activeSection = activeKey ? NAV_ITEMS.find((item) => item.key === activeKey) : null;

		return (
			<>
				<div className={`sidenav${!activeKey ? " sidenav-collapsed" : ""}`}>
					<div className="sidenav-rail">
						{NAV_ITEMS.map((item) => (
							<div
								key={item.key}
								className={`sidenav-rail-item${activeKey === item.key ? " active" : ""}`}
								onClick={(e) => this.handleRailClick(item.key)}
							>
								<Framework.Elements.NavGroup
									parentTextVariant={null}
									parentTargetPath={item.targetPath}
									parentId={item.key}
									parentLinkText={item.label}
									parentIcon={item.icon}
									history={history}
									path={path}
									renderChildrenExternally={true}
									parentColor={item.color}
									checkoutItems={this.props.items}
									sessions={this.props.sessions}
								>
									{item.children ? item.children(this.props) : null}
								</Framework.Elements.NavGroup>
							</div>
						))}
					</div>

					{/* Sub-panel: renders the active section's children directly */}
					{activeKey && activeSection?.children && (
						<div className="sidenav-subpanel">
							<p className="sidenav-subpanel-title" style={{ color: activeSection.color }}>{activeSection.label}</p>
							<ul className="sidenav-subpanel-list" style={{ "--section-color": activeSection.color }}>
								{activeSection.children(this.props)}
							</ul>
						</div>
					)}
				</div>
			</>
		);
	}
}

export default Framework.Components.withRootState(SidebarContent);
